import Vue from "vue";
import axios from "axios";

const host = window.location.host;
let lang = localStorage.getItem("lang_playmix");
export default new Vue({
  data() {
    return {
      ar: {
        arLanguage: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false,
        dataLoaded: false
      },
      browse: {
        category: []
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created() {
    if (host.includes("playmix")) {
      this.getBrowse();
    }
  },
  methods: {
    async getHotPicks(subcate) {
      let isload = "";
      let subCate = [];
      let allplaymixData = [];
      let subcateg = [];
      let allDataplaymix = [];
      let dataLoaded = false;

      let live = `http://cook.grabmobi.com/`;
      let local = `http://[::1]/PuretechGlobalContentPortal`;

      //get subcategory under game
      // let subplaymix = await axios.get(
      //   `${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=2&limit=4&offset=0&domain=${host}`
      // );

      //get subcategory from getBrowse()
      subcateg = subcate;

      //get random number
      var oneHourInMs = 3600000;
      var currentTimeInMs = new Date().getTime();  // UTC time
      var timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
      var numberForToday = timeInHour % 12;
      // zero-filling of numbers less than four digits might be optional for you
      // zero-filled value will be a string to maintain its leading 0s
      var DigitNumber = numberForToday.toString();
      while(DigitNumber.length < 2)
      {
        DigitNumber = 0+Number(DigitNumber);
      }

      for (let i = 0; i < subcateg.length; i++) {
        allDataplaymix = await axios.get(
          `${live}/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=${subcateg[i].subcategory}&limit=50&offset=0&domain=${host}&lang=${lang}`
        );

        let divide = DigitNumber % 2;
        if(divide == 0){
          allDataplaymix.data.data.sort((a, b) => {
            //to sort random
            return Math.random()-0.5;
          });
        }else{
          allDataplaymix.data.data.sort((a, b) => {
            //to sort random
            return 0.5 - Math.random();
          });
        }

        let data_slice = allDataplaymix.data.data.slice(0,6)

        let subcate = subcateg[i].subcategory;
        allplaymixData[subcate] = new Array();
        allplaymixData[subcate] = data_slice
      }

      isload = true;
      dataLoaded = true;
      this.main.hotpicks = allplaymixData;
      (subcate.length >= 4) ? this.main.subcategory = subcateg.slice(1,4) : this.main.subcategory = subcateg;
      this.main.isLoad = isload;
      this.main.dataLoaded = dataLoaded;
    },
    getBrowse() {
      let live = `http://cook.grabmobi.com`;
      let local = `http://[::1]/PuretechGlobalContentPortal`;

      axios
        .get(
          `${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=video&subcategory=3&limit=100&offset=0&domain=${host}&lang=${lang}`
        )
        .then(res => {
          let data = res.data.data;
          let temp = [];
          data.map(item => {
            item.title_english = item.subcategory;
            item.route = item.title_english.toLowerCase();
            let trans = JSON.parse(item.subcategory_translate);
            if (trans != null) {
              let trans_len = Object.keys(trans).length;
              let trans_arr = Object.keys(trans);

              for (let i = 0; i < trans_len; i++) {
                item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
              }
            }

            let icon = JSON.parse(item.subcategory_icon);
            if (icon != null) {
              for (let [key, value] of Object.entries(icon)) {
                if (key == host) {
                  item.icon = icon[key]["class"];
                }else{
                  item.icon = icon["mobiflix.vip"]["class"];
                }
              }
            }

            temp.push(item);
          });

          let item_temp = temp.map(function(v) {
            delete v.category_translate;
            delete v.category_translate;
            delete v.category_icon;
            delete v.subcategory_translate;
            delete v.subcategory_icon;
            delete v.thumbnail_url;
            delete v.cover_img;
            return v;
          });
          this.getHotPicks(item_temp);
          this.browse.category = item_temp;
        });
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/playmix/playmix.js